import { useEnforceAccessControl } from '@/hooks';

export default function PrivateAction({
  children,
  requiredRoles = [],
  requiredPermissions = [],
  bypassAuthCheck = false,
}) {
  const isAuthorized = useEnforceAccessControl({
    requiredRoles,
    requiredPermissions,
    bypassAuthCheck,
  });

  if (!isAuthorized) {
    return null;
  }

  return children;
}
